import { Calculator, FileText, Receipt, Shield, Building2, ClipboardCheck } from 'lucide-react';
import type { Service } from '@/lib';

export const SERVICES: Service[] = [
  {
    id: 'irs',
    title: 'Declaração de IRS',
    description: 'Preparação e entrega da declaração de IRS para particulares e profissionais liberais. Análise completa de deduções fiscais, otimização de benefícios e esclarecimento de dúvidas. Garantimos o cumprimento dos prazos e a maximização do reembolso.',
    icon: 'Receipt'
  },
  {
    id: 'iva',
    title: 'Gestão de IVA',
    description: 'Processamento e entrega de declarações periódicas de IVA. Análise de operações, validação de documentos, cálculo de imposto a pagar ou a recuperar. Apoio completo no cumprimento das obrigações fiscais em IVA.',
    icon: 'Calculator'
  },
  {
    id: 'lancamentos',
    title: 'Lançamentos Contabilísticos',
    description: 'Registo e organização de todas as operações contabilísticas da sua empresa. Lançamento de faturas, recibos, despesas e outras operações. Manutenção da contabilidade atualizada e em conformidade com as normas.',
    icon: 'FileText'
  },
  {
    id: 'apoio-administrativo',
    title: 'Apoio Administrativo',
    description: 'Suporte completo na gestão administrativa do seu negócio. Organização de documentação, arquivo digital, gestão de correspondência e apoio em processos burocráticos. Libertamos o seu tempo para focar no essencial.',
    icon: 'ClipboardCheck'
  },
  {
    id: 'seguranca-social',
    title: 'Segurança Social',
    description: 'Gestão de obrigações perante a Segurança Social. Processamento de declarações mensais, apoio em questões relacionadas com contribuições, benefícios e regularizações. Garantimos o cumprimento de todos os prazos.',
    icon: 'Shield'
  },
  {
    id: 'consultoria',
    title: 'Consultoria Fiscal',
    description: 'Aconselhamento especializado em matérias fiscais e contabilísticas. Análise de situações específicas, planeamento fiscal, esclarecimento de dúvidas e apoio na tomada de decisões. Soluções personalizadas para cada cliente.',
    icon: 'Building2'
  }
];
